export default "__VITE_PUBLIC_ASSET__88b8777b__"